import { fetchV1 } from 'helpers/fetch.js';

const baseUrl = '/bookmarks';
const pruneUrl = 'bookmark';

export default {
  create(content_id) {
    const req = fetchV1.post(baseUrl, { content_id });
    fetchV1.pruneKey(pruneUrl);
    return req;
  },
  remove(content_id) {
    const req = fetchV1.delete(`${baseUrl}/${content_id}`);
    fetchV1.pruneKey(pruneUrl);
    return req;
  },
};
